import { VehicleNumberPlate } from '~/shared';

export const formatNumberPlate = (numberPlate: VehicleNumberPlate): string => {
	const regex = /^([A-Za-z])(\d{3})([A-Za-z]{2})(\d{2,3})$/;
	const match = `${numberPlate.text}${numberPlate?.region}`.match(regex);

	if (match) {
		const [, letter1, digits1, letters2, digits2] = match;
		return `${letter1.toUpperCase()} ${digits1} ${letters2.toUpperCase()} ${digits2}`;
	}

	return numberPlate.text;
};
